import script from "./AnnouncementList.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementList.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementList.vue?vue&type=style&index=0&id=62336ba4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62336ba4"]])

export default __exports__